<fieldset [formGroup]="valueGroup" *ngIf="visible$ | async">
    <ng-container *ngrxLet="valueFunctionalElement$; let valueFunctionalElement">
        <ng-container *ngIf="valueFunctionalElement.choices">
            <div class="row">
                <p class="col-sm-9 col-12" [innerHTML]="valueFunctionalElement.description"></p>
                <span class="text-end col-sm-3 col-12 text-end filter-text">{{ elementTypeLabel$ | async }}</span>
            </div>
        </ng-container>
        <label class="col-form-label" for="{{ valueFunctionalElement.id }}">{{ valueFunctionalElement.label }}</label>
        <span class="col-form-label" *ngIf="valueFunctionalElement.expectedValueText">
            {{ valueFunctionalElement.expectedValueText }}</span
        >
        <div class="row mb-3">
            <div class="col-8 col-lg-3">
                <div [class.input-group]="!!valueFunctionalElement.unit">
                    <input
                        class="form-control input-md value-input"
                        id="{{ valueFunctionalElement.id }}"
                        [formControl]="inputFieldControl"
                        [attr.inputmode]="inputMode$ | async"
                        [ngClass]="{ 'validator-error': inputFieldControl.invalid }"
                        [placeholder]="placeholder$ | async"
                        (input)="validateNumberValue($event)"
                    />
                    <ng-container *ngIf="!!valueFunctionalElement.unit">
                        <span class="input-group-text">{{ valueFunctionalElement.unit }}</span>
                    </ng-container>
                </div>
            </div>
            <div *ngIf="displayNACheckbox$ | async" class="col-auto text-center">
                <div class="not-applicable">
                    <div class="checkbox-container">
                        <input
                            type="checkbox"
                            id="{{ valueFunctionalElement.id }}-not-applicable"
                            class="form-control"
                            [formControl]="checkboxControl"
                            [placeholder]="placeholder$ | async"
                        />
                        <label for="{{ valueFunctionalElement.id }}-not-applicable"
                            ><fa-icon *ngIf="checkboxControl.value" [icon]="faCheck" size="2x"></fa-icon>
                        </label>
                    </div>
                    <label
                        translate="F4M_NOT_APPLICABLE_LABEL"
                        for="{{ valueFunctionalElement.id }}-not-applicable"
                    ></label>
                </div>
            </div>
        </div>
        <div class="row mb-3" *ngIf="showRemarksField$ | async">
            <div class="col">
                <pace-forms-input-text
                    [id]="valueFunctionalElement.remarksXmlId"
                    [label]="valueFunctionalElement.remarksLabel"
                    [formControl]="remarksControl"
                ></pace-forms-input-text>
            </div>
        </div>
    </ng-container>
</fieldset>
